<template>
  <vs-popup fullscreen title="Resumo de Convidados" :active="show" @update:active="$emit('update:show')">
    <template v-if="scheduleSuggestion">
      <p class="py-2">
        Situação de convidados <span v-if="event && event.title">da agenda <b>"{{event.title}}" </b></span>para a período <i class="font-bold">{{formatDate(scheduleSuggestion.suggestion_start_at)}}</i> até <i class="font-bold">{{formatDate(scheduleSuggestion.suggestion_finish_at)}}</i>
      </p>
      <guests-table
        :guests="formattedAndFilteredGuests"
        @open-justifications="$emit('open-justifications',$event)"
        :fields="[
          { key: 'situation', label: 'Situação'},
          { key: 'name', label: 'Nome' },
          { key: 'email', label: 'Email'},
        ]"
      >
        <template #situation="situation">
          <span
            :class="[{'REJ':'text-danger','CON':'text-success','CONREJ':'text-purple','PEN':'text-warning'}[situation.guest.situation]]"
          >
            {{$t(`schedule_guest.situation.${situation.guest.situation}`)}}
          </span>
          <template v-if="situation.guest.situation === 'REJ'">
            <b-button v-tooltip="{content:'Abrir justificativa', duration:{show:100, hide:100}}" @click="$emit('open-justifications',situation.guest)" pill size="sm" variant="outline-warning">
              <b-icon-exclamation-triangle font-scale="1" class="text-warning"/>
            </b-button>
          </template>
        </template>
      </guests-table>
    </template>
  </vs-popup>
</template>

<script>
import GuestsTable from './GuestsTable.vue'
import {
  BIconExclamationTriangle,
  BButton,
} from 'bootstrap-vue'


export default {
  components:{
    GuestsTable,
    BButton,
    BIconExclamationTriangle,
  },
  props: {
    scheduleSuggestion: {
      type: Object,
      default: null
    },
    eventGuests: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: false
    },
    event: {
      type: Object,
      default: null
    }
  },
  data: () => ({
  }),
  computed: {
    formattedAndFilteredGuests() {
      const filterByIdentityEmail = (a, b) => {
        const {email: aEmail} = this.getGuestIdentity(a)
        const {email: bEmail} = this.getGuestIdentity(b)
        return aEmail > bEmail ? 1 : -1
      }

      const formattedGuests = this.eventGuests.map( guest => {
        return {
          ...guest,
          situation: this.getGuestSituation(guest, this.scheduleSuggestion)
        }
      }).sort(filterByIdentityEmail)

      const pendingGuests = formattedGuests.filter((guest) => guest.situation === 'PEN')
      const rejectedGuests = formattedGuests.filter((guest) => guest.situation === 'REJ')
      const confirmedGuests = formattedGuests.filter((guest) => guest.situation === 'CON')
      const corruptedGuests = formattedGuests.filter((guest) => guest.situation === 'CONREJ')

      return [
        ...confirmedGuests,
        ...rejectedGuests,
        ...pendingGuests,
        ...corruptedGuests
      ]
    },
    guestName() {
      return (this.guest && this.guest.name) || (this.guest && this.guest.entity && this.guest.entity.name) || null
    },
    hasAnyEventJustification() {
      if (this._.isArray(this.items) && this.items.length > 0) {
        this._.some(this.items, 'schedule_event_id')
      } else return false
    },
  },
  methods: {
    formatDate(timestamp) {
      const format = 'ddd DD/MM/YYYY HH:mm'
      return this.$utils.format.dateWithFormat(timestamp, format)
    },
    getGuestIdentity(guestModel) {
      if (guestModel.entity_id && guestModel.entity_type) {
        return {
          name: guestModel.entity.name,
          email: guestModel.entity.email,
        }
      } else {
        return {
          name: guestModel.name,
          email: guestModel.email,
        }
      }
    },
    equalGuests(guest1, guest2) {
      const guestIdentity1 = this.getGuestIdentity(guest1)
      const guestIdentity2 = this.getGuestIdentity(guest2)
      return (
        guestIdentity1.email === guestIdentity2.email
      )
    },
    getGuestSituation(guest, suggestion) {
      const confirmed = suggestion.guests.find((confirmedGuest) => {
        return this.equalGuests(confirmedGuest, guest)
      })
      const rejected = suggestion.justifications.find((justification) => {
        return justification.suggestion_guest_id === guest.id
      })

      if (confirmed && !rejected ) {
        return 'CON' // Confirmado
      } else if (rejected && !confirmed) {
        return 'REJ' // Rejeitado
      } else  if (!rejected && !confirmed) {
        return 'PEN' // Pendente
      } else if (rejected && confirmed) {
        return 'CONREJ' // Confirmado e Rejeitado (não deve ocorrer)
      }
    },
    formatDate(timestamp) {
      const format = 'ddd DD/MM/YYYY HH:mm'
      return this.$utils.format.dateWithFormat(timestamp, format)
    },
  }
}
</script>

<style lang="scss">


</style>